module.exports = __webpack_public_path__ + "img/solution7.e3673ba3.jpg";